class StickyButton extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        } else {
            this.init();
        }
    }

    init() {
        const forElementId = this.dataset.for;

        if (forElementId) {
            this.sourceElement = document.getElementById(forElementId);
            if (!this.sourceElement) return console.error("Can't find sourceElement with id", forElementId);
            this.createObserver();
        }
    }

    createObserver() {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    this.classList.add('show');
                } else {
                    this.classList.remove('show');
                }
            });
        });

        this.observer.observe(this.sourceElement);
    }
}

customElements.define('sticky-button', StickyButton);
